import React from "react";
import { toUrl } from "../../lib/config";
import Eller from "../../assets/images/eller.png";

/** Kartlara basacağımız veri yapısı */
export type Doctor = {
    id: string | number;
    name: string;                 // “Opr. Dr. …”
    subtitle: string;             // “Beyin ve Sinir Cerrahı” vb.
    photo: string;                // büyük kesilmiş PNG/JPG (arka planı transparan olursa en iyi)
    icon?: React.ReactNode;       // bootstrap-icons / svg
};

type Props = {
    items: Doctor[];
};

// Remove common Turkish medical/academic titles from the beginning of a name
const cleanName = (value: string): string => {
    let v = value.trim();
    // Normalize spaces and dots around titles
    // Remove multiple known prefixes iteratively if present
    const patterns: RegExp[] = [
        /^prof\.?\s*dr\.?\s*/i,
        /^doç\.?\s*dr\.?\s*/i,
        /^dr\.?\s*öğr\.?\s*üyesi\s*/i,
        /^uzm\.?\s*dr\.?\s*/i,
        /^opr\.?\s*dr\.?\s*/i,
        /^dr\.?\s*/i,
    ];
    let matched = true;
    while (matched) {
        matched = false;
        for (const r of patterns) {
            if (r.test(v)) {
                v = v.replace(r, "");
                matched = true;
            }
        }
    }
    return v.trim();
};

// Create a URL-friendly slug from a doctor's name (with Turkish character mapping)
const slugify = (value: string): string => {
    const trMap: Record<string, string> = {
        "ş": "s", "Ş": "s",
        "ğ": "g", "Ğ": "g",
        "ı": "i", "İ": "i",
        "ç": "c", "Ç": "c",
        "ö": "o", "Ö": "o",
        "ü": "u", "Ü": "u",
    };

    const mapped = value.replace(/[şŞğĞıİçÇöÖüÜ]/g, (ch) => trMap[ch] || ch);

    return mapped
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // remove remaining diacritics
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, "") // remove non-alphanumeric
        .trim()
        .replace(/\s+/g, "-") // spaces to dashes
        .replace(/-+/g, "-"); // collapse multiple dashes
};

const DoctorsGrid: React.FC<Props> = ({ items }) => {
    const ImgWithFallback: React.FC<{ src?: string; alt: string; className?: string }> = ({ src, alt, className }) => {
        const input = src || "";
        const raw = /^https?:\/\//i.test(input)
            ? input
            : (input.startsWith('/api/') ? input : (input ? `/api/media/${input}` : ''));
        const abs = /^https?:\/\//i.test(raw) ? raw : toUrl(raw);
        const [current, setCurrent] = React.useState(abs);
        return (
            <img
                src={current}
                alt={alt}
                className={className}
                crossOrigin="anonymous"
                onError={(e) => {
                    const cur = e.currentTarget.getAttribute('src') || '';
                    const next = cur === abs ? raw : abs;
                    if (next && next !== cur) e.currentTarget.src = next;
                }}
            />
        );
    };
    return (
        <section className="doctors-grid">
            <div className="container">
                <div className="grid">
                    {items.map((d) => (
                        <article key={d.id} className="doc-card">
                            <div className="photo-wrap">
                                <ImgWithFallback src={d.photo} alt={d.name} className="photo" />
                            </div>

                            {/* Dairesel yeşil ikon – overlap */}
                            <div className="spec-icon btIco">
                                <div className="btIcoHolder">
                                    {/* <i className="bi">{d.icon ?? <span className="bi-brilliance" />}</i> */}
                                    <img src={Eller} alt={d.name} className="bi" height={50} />
                                </div>
                            </div>

                            {/* Branş / alt başlık */}
                            <p className="subtitle">
                                {d.subtitle}
                            </p>

                            {/* İsim */}
                            <h3 className="doc-name">{d.name}</h3>

                            {/* CTA’lar */}
                            <div className="ctas">
                                <a
                                    className="btn btn-red btn-cv"
                                    href={`/hekim/${slugify(cleanName(d.name))}`}
                                >
                                    Özgeçmiş <span className="bi bi-chevron-right" />
                                </a>
                                <a className="btn btn-red btn-appointment" href="https://mgonline.hgkurumsal.com.tr/#/hizli-randevu" target="_blank">
                                    Randevu Al <span className="bi bi-chevron-right" />
                                </a>
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default DoctorsGrid;

